module.exports = "https://www.gc-pro.gnp.com.mx/d90f0d0468998861597c8b94d4ebb6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/otp/3.png
// module id = 1038
// module chunks = 0 1